import React, { Component } from 'react'
import { connect } from 'react-redux'
import Menu from '@mui/material/Menu'
import Paper from '@mui/material/Paper'
import FormControlLabel from '@mui/material/FormControlLabel'
import TablePagination from '@mui/material/TablePagination'
import SearchIcon from '@mui/icons-material/Search'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'
import _ from 'lodash'

import { removeAccents } from '../../../util/stringUtil'
import { atualizarFiltros } from '../../../actions/filtrosActions'
import { recuperarOpcoesAuditor } from '../../../actions/itensActions'
import styles from './MenuFiltrosSelecaoServidor.module.css'
import { restartWebSocket } from '../../../controllers/alertasController'
import { descartarFotoPessoaRecuperada } from '../../../actions/contextoAplicacaoActions'

const INITIAL_ROWS_PER_PAGE = 20

class MenuFiltrosSelecaoServidor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      anchorEl: null,
      page: 0,
      rowsPerPage: INITIAL_ROWS_PER_PAGE,
      filtrarPor: '',
      somenteAtivos: true
    }
  }

  handleRadioGroupChange(codigoUsuario) {
    const { filtros } = this.props
    this.props.atualizarFiltros({ ...filtros, codigoUsuario })
    this.props.descartarFotoPessoaRecuperada()
    restartWebSocket()
    this.handleMenuClose()
  }

  handleFiltrarPorChange(event) {
    this.setState({ filtrarPor: event.target.value, page: 0 })
  }

  handleMenuClose() {
    this.setState({ anchorEl: null })
  }

  renderMenuHeader() {
    const {
      itens: { opcoesAuditor }
    } = this.props
    const { filtrarPor } = this.state
    return (
      <Grid item md={11} container spacing={1}>
        <Grid item sm={6}>
          <Typography variant='h6' color='primary'>
            Servidor
          </Typography>
          <Typography variant='subtitle1'>Selecione o servidor</Typography>
        </Grid>
        {_.size(opcoesAuditor) ? (
          <Grid item md={6}>
            <TextField
              onKeyDown={(event) => event.stopPropagation()}
              id='filtrarPorItems'
              type='search'
              variant='standard'
              className={styles.filtrarPorTextField}
              label={
                <div style={{ alignItems: 'center', display: 'flex' }}>
                  <SearchIcon style={{ height: 18 }} />
                  Pesquisar
                </div>
              }
              value={filtrarPor}
              onChange={(event) => this.handleFiltrarPorChange(event)}
            />
          </Grid>
        ) : null}
      </Grid>
    )
  }

  renderMenuItems() {
    const {
      radioGroupRow,
      itens: {
        opcoesAuditor,
        visao: { informacoesAuditor }
      }
    } = this.props
    const { page, rowsPerPage, filtrarPor } = this.state
    const itemsEntriesFiltered = _.filter(opcoesAuditor, (item) =>
      removeAccents(_.toUpper(item.nome)).includes(removeAccents(_.toUpper(filtrarPor)))
    )
    const itemsEntriesSliced = _.slice(
      itemsEntriesFiltered,
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    )
    const count = _.size(itemsEntriesFiltered)
    return _.size(itemsEntriesFiltered) ? (
      <React.Fragment>
        <Grid item md={11} container>
          <Grid item md={11}>
            <RadioGroup
              row={radioGroupRow || false}
              aria-label={'auditor'}
              value={informacoesAuditor.codigoUsuario}
              onChange={(event) => this.handleRadioGroupChange(event.target.value)}>
              {_.map(itemsEntriesSliced, (usuario, index) => (
                <Grid item xs={10} md={6} key={`item-${index}`}>
                  <FormControlLabel
                    key={_.uniqueId('option-')}
                    value={usuario.codigoUsuario}
                    classes={{ label: styles.label }}
                    control={<Radio color='secondary' classes={{ checked: styles.checked }} />}
                    label={_.toUpper(usuario.nome)}
                  />
                </Grid>
              ))}
            </RadioGroup>
          </Grid>
        </Grid>
        {count ? (
          <Grid item md={11} container>
            <TablePagination
              component={Grid}
              item
              xs={12}
              count={count}
              page={page}
              rowsPerPage={rowsPerPage}
              labelRowsPerPage='Itens por página'
              labelDisplayedRows={({ from, to, count: countNumber }) =>
                `${from}-${to} de ${countNumber}`
              }
              rowsPerPageOptions={[INITIAL_ROWS_PER_PAGE]}
              onPageChange={(event, pageNumber) => this.setState({ page: pageNumber })}
              onRowsPerPageChange={(event) => this.setState({ rowsPerPage: event.target.value })}
            />
          </Grid>
        ) : null}
      </React.Fragment>
    ) : null
  }

  renderMenu() {
    const { handleMenuOnEnter } = this.props
    const { anchorEl } = this.state
    return (
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        TransitionProps={{ onEnter: handleMenuOnEnter }}
        onClose={() => this.handleMenuClose()}
        MenuListProps={{ component: 'div' }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Paper elevation={0} square className={styles.itemsMenuPaper}>
          <Grid container spacing={1} justifyContent='center' style={{ marginTop: 16 }}>
            {this.renderMenuHeader()}
            {this.renderMenuItems()}
          </Grid>
        </Paper>
      </Menu>
    )
  }

  render() {
    const {
      itens: { visao }
    } = this.props
    return visao ? (
      <React.Fragment>
        <Grid container>
          <Grid
            container
            item
            md={12}
            id={`filtro-radio-visao-auditor`}
            justifyContent='flex-end'
            style={{ padding: 0, cursor: 'pointer' }}
            onClick={(event) => this.setState({ anchorEl: event.currentTarget })}>
            <Button color='primary' size='small'>
              Selecionar
            </Button>
          </Grid>
        </Grid>
        {this.renderMenu()}
      </React.Fragment>
    ) : null
  }
}

const mapStateToProps = ({ filtros, itens }) => ({ filtros, itens })

export default connect(mapStateToProps, {
  atualizarFiltros,
  recuperarOpcoesAuditor,
  descartarFotoPessoaRecuperada
})(MenuFiltrosSelecaoServidor)
